// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
    width: 96%;
    display: flex;
    justify-content: center;
    list-style: none;
    border: 1px solid #fff;
    background-color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 5px 0;
    margin-top: 0;
}

.community-page {
    width: 100%;
    display: flex;
    justify-content: center;
    list-style: none;
    background-color: #F5F5F5;
    padding: 5px 0;
    margin-top: 0;
}

.each-page, .next-button, .previous-button {
    border: 1px solid transparent;
    border-radius: 5px;
    outline: none;
    display: flex;
    align-items: center;
    color: #1976d2;
}

.each-page:hover, .next-button:hover, .previous-button:hover {
    color: #fff;
    background-color: #1976d2;
    cursor: pointer;
}

.active {
    font-weight: bolder;
}

.each-page a, .next-button a, .previous-button a {
    outline: none;
    padding: 5px 10px;
}

@media screen and (max-width: 600px) {
    .pagination-container {
        padding: 10px;
        width: 94%;
    }

    .next-button {
        border: 1px solid #acacac80;
        border-radius: 0;
    }

    .each-page, .previous-button {
        border: 1px solid #acacac80;
        border-radius: 0;
    }

    .each-page a, .next-button a, .previous-button a  {
        padding: 5px;
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/css/paginator.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,+BAA+B;IAC/B,gCAAgC;IAChC,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,UAAU;IACd;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":[".pagination-container {\n    width: 96%;\n    display: flex;\n    justify-content: center;\n    list-style: none;\n    border: 1px solid #fff;\n    background-color: #fff;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    padding: 5px 0;\n    margin-top: 0;\n}\n\n.community-page {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    list-style: none;\n    background-color: #F5F5F5;\n    padding: 5px 0;\n    margin-top: 0;\n}\n\n.each-page, .next-button, .previous-button {\n    border: 1px solid transparent;\n    border-radius: 5px;\n    outline: none;\n    display: flex;\n    align-items: center;\n    color: #1976d2;\n}\n\n.each-page:hover, .next-button:hover, .previous-button:hover {\n    color: #fff;\n    background-color: #1976d2;\n    cursor: pointer;\n}\n\n.active {\n    font-weight: bolder;\n}\n\n.each-page a, .next-button a, .previous-button a {\n    outline: none;\n    padding: 5px 10px;\n}\n\n@media screen and (max-width: 600px) {\n    .pagination-container {\n        padding: 10px;\n        width: 94%;\n    }\n\n    .next-button {\n        border: 1px solid #acacac80;\n        border-radius: 0;\n    }\n\n    .each-page, .previous-button {\n        border: 1px solid #acacac80;\n        border-radius: 0;\n    }\n\n    .each-page a, .next-button a, .previous-button a  {\n        padding: 5px;\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
